import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'there_written_docs_surrounding_terms_cond_granting_repayment'

export const dataPointDefinition = {
  retracedId: 'there_written_docs_surrounding_terms_cond_granting_repayment',
  name: 'Is there written documentation surrounding the terms and conditions of the granting and repayment of advances and loans?',
  description:
    'The intent of this question is to understand if there is WRITTEN documentation for the loan/advance terms and conditions. For both the granting process (the initial loan giving) and the re-payment process (how and when loans are to be paid back.)',
  meta: {
    slcpMeta: {
      key: 'wb-17--3',
      number: 'WB-WAGE-116',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-17--3', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35130,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
